/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.controller('ComponentsOrderStep', [
  '$scope',
  '$location',
  '$translate',

  function ($scope, $location, $translate) {
    $scope.componentOrderStep = $scope.$parent.createStep(
      $translate.instant(`component-editor.step-order.${$scope.component.componentType}.closed`),
      $translate.instant(`component-editor.step-order.${$scope.component.componentType}.active`),
      '<components-order-editor components="components"></components-order-editor>',
    );

    $scope.componentOrderStep.validate = function () {
      this.valid =
        $scope.components.length >= 2 && !($scope.components.includes(null) || $scope.components.includes(undefined));

      if (!this.valid) {
        this.active = true;
        this.tags = [];
      } else {
        const img0 = `<span><svg xmlns="http://www.w3.org/2000/svg"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#icons-sprite_${$scope.components[0].icon}"></use></svg></span>`;
        const img1 = `<span><svg xmlns="http://www.w3.org/2000/svg"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#icons-sprite_${$scope.components[1].icon}"></use></svg></span>`;
        this.tags = [
          {
            name: `Input 1: ${img0}<b>${_.escape($scope.components[0].name)}</b>`,
          },
          {
            name: `Input 2: ${img1}<b>${_.escape($scope.components[1].name)}</b>`,
          },
        ];
      }

      return this.valid;
    };

    $scope.componentOrderStep.validate();
  },
]);
